module.exports = __webpack_public_path__ + "static/media/work_with_households_icon.77bd1014.svg";